import React from 'react'
import { Link } from 'react-router-dom'
import constants from '../../constants'
import _ from 'lodash'
import { priceFormat } from 'app/utils'

class ConstructionType extends React.Component {
  constructor(props) {
    super(props);
    this.item = props.item;
    this.onSelect = props.onSelect;
    this.onShowInfo = props.onShowInfo;
  }

  onItemSelected() {
    this.onSelect(this.item.id);
  }

  onShowPopup(e) {
    e.preventDefault();
    e.stopPropagation();
    this.onShowInfo(this.item);
  }

  get isSelected() {
    return _.get(this.props, 'selected.id') == this.item.id;
  }

  render() {
    return (
      <li key={this.item.id} onClick={this.onItemSelected.bind(this)} className={`construction-types-list-item selectable-block ${this.isSelected ? 'selected' : ''}`}>
        <div className='selectable-block-indicator'></div>
        <div className='construction-types-photo' style={{backgroundImage: "url(" + _.get(this.item, 'preview.url') + ")"}}/>
        <div className='construction-types-content'>
          <div className='construction-types-title'>
            { this.item.title }
          </div>
          <div className='construction-types-price'>
            {`от ${priceFormat(this.item.price)}`}
        </div>
          <div className='construction-types-description'>
            {this.item.short_desc}
          </div>
          <a className="see-more popup-door-show" href={`#popup-door-${this.item.slug}`}>Узнать больше</a>
          {/*{this.item.description.length ? (<a className='see-more' onClick={ this.onShowPopup.bind(this) } href='#'>Узнать больше</a>) : null }*/}
        </div>
      </li>
    )
  }
}

export default ConstructionType;



// WEBPACK FOOTER //
// ./app/javascript/app/components/construction_types/construction_type.jsx